<h1 mat-dialog-title cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragHandle>
  {{'map.attachment_dialog.title' | translate}}
</h1>

<mtx-grid [data]="dataGrid" [columns]="columnGrid" [showColumnMenuHeader]="false" [hidePageSize]="true"
  [noResultText]="'map.attachment_dialog.no_results' | translate" [showFirstLastButtons]="false" [rowStriped]="true"
  [showPaginator]="false" [emptyValuePlaceholder]="'-'">
</mtx-grid>

<mat-dialog-actions align="end">
  <button mat-stroked-button color="primary" mat-dialog-close>
    {{ 'common.close' | translate }}
  </button>
</mat-dialog-actions>
